export default "__VITE_ASSET__abc69c60__"